(function () {
  function initQuantity(root) {
    var packsScript = root.querySelector(".quantity__packs-data");
    var packs = [];

    if (packsScript) {
      try {
        packs = JSON.parse(packsScript.textContent);
      } catch (error) {
        packs = [];
      }
    }

    if (!packs.length) {
      return;
    }

    var productVariantId = root.dataset.productVariantId || null;

    var input = root.querySelector(".quantity__range-input");
    var track = root.querySelector(".quantity__range-track");
    var labels = root.querySelectorAll(".quantity__range-labels span");
    var output = root.querySelector(".quantity__output");
    var valueEl = root.querySelector(".quantity__step-value");
    var hintEl = root.querySelector(".quantity__hint");
    var badgeEl = root.querySelector(".quantity__body .quantity__badge");
    var headingEl = root.querySelector(".quantity__heading");
    var pensEl = root.querySelector(".quantity__result-value");
    var descriptionEl = root.querySelector(".quantity__description");
    var btnEl = root.querySelector(".quantity__btn");

    if (!input || !track || !output || !valueEl || !hintEl || !badgeEl || !headingEl || !pensEl || !descriptionEl || !btnEl) {
      return;
    }

    var thumbSize = 28;
    var isFirstUpdate = true;
    var heightTransitionTimer = null;
    var currentPackIndex = 0;

    function getStepPosition(index) {
      var min = Number(input.min);
      var max = Number(input.max);
      var ratio = (index + 1 - min) / (max - min);
      var trackWidth = track.offsetWidth;

      return thumbSize / 2 + ratio * (trackWidth - thumbSize);
    }

    function alignLabels() {
      labels.forEach(function (label, index) {
        label.style.left = getStepPosition(index) + "px";
      });
    }

    function applyPack(pack) {
      valueEl.textContent = pack.valueLabel || "";
      hintEl.textContent = pack.hint || "";
      badgeEl.textContent = pack.badge || "";
      headingEl.textContent = pack.heading || "";
      pensEl.textContent = pack.pens || "";
      descriptionEl.textContent = pack.description || "";
      btnEl.textContent = pack.btn || "";
    }

    function resetOutputHeight() {
      output.style.height = "auto";
    }

    function updateContent() {
      var index = Number(input.value) - 1;
      var pack = packs[index];

      if (!pack) {
        return;
      }

      currentPackIndex = index;

      if (isFirstUpdate) {
        applyPack(pack);
        resetOutputHeight();
        isFirstUpdate = false;
        return;
      }

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        applyPack(pack);
        resetOutputHeight();
        return;
      }

      var startHeight = output.offsetHeight;

      output.style.height = startHeight + "px";
      applyPack(pack);

      output.style.height = "auto";
      var endHeight = output.offsetHeight;
      output.style.height = startHeight + "px";

      window.clearTimeout(heightTransitionTimer);
      window.requestAnimationFrame(function () {
        output.style.height = endHeight + "px";
      });

      function onTransitionEnd(event) {
        if (event.propertyName !== "height") {
          return;
        }

        resetOutputHeight();
        output.removeEventListener("transitionend", onTransitionEnd);
      }

      output.addEventListener("transitionend", onTransitionEnd);
      heightTransitionTimer = window.setTimeout(function () {
        resetOutputHeight();
        output.removeEventListener("transitionend", onTransitionEnd);
      }, 400);
    }

    function parsePensCount(pensText) {
      var match = String(pensText).match(/(\d+)/);
      return match ? Number(match[1]) : 0;
    }

    function resolveVariant(targetPens) {
      if (!productVariantId || targetPens <= 0) return null;
      return { variantId: productVariantId, quantity: targetPens };
    }

    btnEl.addEventListener("click", async function () {
      var pack = packs[currentPackIndex];
      if (!pack) return;

      var targetPens = parsePensCount(pack.pens);
      var resolved = resolveVariant(targetPens);

      if (!resolved) return;

      var initialText = btnEl.textContent;
      btnEl.disabled = true;
      btnEl.textContent = "Adding...";

      try {
        var sectionsPayload = {};
        var drawer = document.querySelector("[data-cart-drawer-root]");
        if (drawer && drawer.dataset.sectionId) {
          var cartPath = (window.__glowRoutes && window.__glowRoutes.cartUrl) || "/cart";
          sectionsPayload = {
            sections: drawer.dataset.sectionId,
            sections_url: cartPath.startsWith("/") ? cartPath : "/" + cartPath,
          };
        }

        var res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(
            Object.assign(
              { id: Number(resolved.variantId), quantity: resolved.quantity },
              sectionsPayload
            )
          ),
        });

        if (!res.ok) throw new Error("Add to cart failed");
        var data = await res.json();

        if (data.sections && window.cartUi && window.cartUi.applyBundledSections) {
          window.cartUi.applyBundledSections(data.sections);
        }

        if (window.cartUi) {
          await window.cartUi.syncCartCountFromApi();
          if (!window.cartUi.isDrawerOpen()) {
            window.cartUi.openDrawer();
          }
        }
      } catch (err) {
        console.error("Quantity add to cart error:", err);
      } finally {
        btnEl.disabled = false;
        btnEl.textContent = initialText;
      }
    });

    labels.forEach(function (label, index) {
      label.addEventListener("click", function () {
        input.value = String(index + 1);
        input.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });

    input.addEventListener("input", updateContent);
    window.addEventListener("resize", function () {
      alignLabels();
      resetOutputHeight();
    });

    alignLabels();
    updateContent();
  }

  document.querySelectorAll(".quantity .quantity__steps").forEach(initQuantity);
})();
